export class BiomarkerQuantitativeData {
  private biomarkerName: string;
  private data: (number | null)[] | (number | null)[][];
  private sliceIndex: string;

  constructor(
    biomarkerName: string,
    data: (number | null)[] | (number | null)[][],
    sliceIndex: string,
  ) {
    this.biomarkerName = biomarkerName;
    this.data = data;
    this.sliceIndex = sliceIndex;
  }

  public getBiomarkerName(): string {
    return this.biomarkerName;
  }

  public getData(): (number | null)[] | (number | null)[][] {
    return this.data;
  }

  public getSliceIndex(): string {
    return this.sliceIndex;
  }

  public getFirstValue(): number | null {
    if (!this.data || this.data.length === 0) return null;
    const first = this.data[0];
    if (typeof first === 'number' && Number.isFinite(first)) return first;
    if (Array.isArray(first) && first.length > 0) {
      const nested = first[0];
      if (typeof nested === 'number' && Number.isFinite(nested)) return nested;
    }
    return null;
  }

  public getFormattedValue(precision = 2): string {
    if (!this.data || this.data.length === 0) return '-';
    if (Array.isArray(this.data[0])) {
      return (this.data as (number | null)[][])
        .map(row =>
          row
            .map(v =>
              v !== null && v !== undefined && Number.isFinite(v)
                ? v.toFixed(precision)
                : '-',
            )
            .join(', '),
        )
        .join('; ');
    }
    const flat = this.data as (number | null)[];
    if (flat.length === 1) {
      const val = flat[0];
      return val !== null && val !== undefined && Number.isFinite(val)
        ? val.toFixed(precision)
        : '-';
    }
    return flat
      .map(v =>
        v !== null && v !== undefined && Number.isFinite(v)
          ? v.toFixed(precision)
          : '-',
      )
      .join(', ');
  }
}
